import { render } from "./DependentModal.vue?vue&type=template&id=6f23cc21&scoped=true&ts=true"
import script from "./DependentModal.vue?vue&type=script&lang=ts"
export * from "./DependentModal.vue?vue&type=script&lang=ts"

import "./DependentModal.vue?vue&type=style&index=0&id=6f23cc21&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f23cc21"]])

export default __exports__